export const ERR_MSG = {
  COMMON: {
    NOT_FOUND: `データが存在しません \n（NOT_FOUND）`,
    UNAUTHORIZED: `セッションの有効期限が切れました \n（UNAUTHORIZED）`,
    PROFILE_UNSPECIFIED: `プロフィールを選択してください \n（PROFILE_UNSPECIFIED）`,
    ALREADY_EXISTS: `既にデータが存在します \n（ALREADY_EXISTS）`,
    INVALID_ARGUMENT: `無効なリクエストです \n（INVALID_ARGUMENT）`,
    INTERNAL_ERROR: `時間を置いて再度お試しください \n（INTERNAL_ERROR）`,
    /** BFF側でエラーコードが追加されてFEで検知できなかった場合に表示するメッセージ */
    DEFAULT: `不明なエラーが発生しました`,
  },
  POST_REVIEW: {
    UNSPECIFIED: `不明なエラーが発生しました \n（UNSPECIFIED）`,
    INVALID_TITLE: `レビュータイトルは0文字〜32文字の範囲で入力してください \n（INVALID_TITLE）`,
    INVALID_COMMENT: `レビューコメントは30文字〜1000文字の範囲で入力してください \n（INVALID_COMMENT）`,
    NO_REVIEWER_NAME: `ニックネームが未登録です \n（NO_REVIEWER_NAME）`,
    UNAVAILABLE_REVIEWER_NAME: `ニックネームが利用不可です \n（UN_AVAILABLE_REVIEWER_NAME）`,
    REVIEWER_NAME_IS_REGISTERED: `ニックネームが登録済みです \n（REVIEWER_NAME_IS_REGISTERED）`,
    INVALID_REVIEWER_NAME: `禁則文字が含まれているためニックネームが利用不可です \n（INVALID_REVIEWER_NAME）`,
  },
  PROFILE: {
    USER_NOT_FOUND: `削除対象の会員情報が存在しません \n（USER_NOT_FOUND）`,
    PROFILE_NOT_FOUND: `削除対象のプロフィールが存在しません \n（PROFILE_NOT_FOUND）`,
    PROFILE_INACTIVE: `削除対象のプロフィールが「無効」です \n（PROFILE_IN_ACTIVE）`,
    DEFAULT_PROFILE_CANNOT_DELETE: `削除対象のプロフィールが削除できないプロフィールです \n（DEFAULT_PROFILE_CANNOT_DELETE）`,
  },
} as const;
